import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthenticationService } from '../../shared/services/auth/authentication.service';
import { AlertifyService } from '../../shared/services/alertify/alertify.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authenticationService = inject(AuthenticationService);
  const alertifyService = inject(AlertifyService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const fetchedError = error.error;

      if (fetchedError instanceof Blob) {
        return throwError(() => fetchedError);
      }

      let message =
        error.error?.message ??
        error.message ??
        'An unexpected error occurred.';

      switch (error.status) {
        case 0:
          message = 'Failed to reach server';
          break;

        case 401:
          if (authenticationService.isAuthenticated)
            authenticationService.forceUserOut();
          break;

        // case 403:
        //   alertifyService.error(message);

        //   if (authenticationService.isAuthenticated)
        //     authenticationService.forceUserOut();
        //   break;

        case 404:
          message = message || '404 Not Found';
          break;
      }

      return throwError(() => ({ status: error.status, message }));
    }),
  );
};
